import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * One line of read-only facts about a row: `₹220 / mo · Monthly Rate · News Paper`.
 *
 * Replaces the row of outlined chips these used to be. Those chips were drawn in primary blue —
 * the same blue as every tappable thing on the screen — so vendors read plain labels as
 * buttons. They also cost a full 34px row per card. As text they cost one line and read as
 * what they are.
 *
 * Chips are still right for a state that must pop (ON/OFF, "20% off", "Auto-managed"); pass
 * those as `trailing` so they sit on this same line instead of adding another.
 *
 * @param items    array of nodes/strings; falsy entries are dropped, so callers can inline
 *                 conditions without building the array first
 * @param trailing chips or other nodes pinned after the text
 * @param sx       merged onto the row (spacing only)
 */
export default function MetaLine({ items = [], trailing = null, sx = {} }) {
    const parts = items.filter(Boolean);
    if (!parts.length && !trailing) return null;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap', ...sx }}>
            {parts.map((part, i) => (
                <React.Fragment key={i}>
                    {i > 0 && (
                        <Typography variant="caption" component="span" sx={{ color: 'text.disabled' }}>
                            ·
                        </Typography>
                    )}
                    <Typography variant="caption" component="span" sx={{ color: 'text.secondary' }}>
                        {part}
                    </Typography>
                </React.Fragment>
            ))}
            {trailing}
        </Box>
    );
}
